import React, {useEffect, useState} from 'react';
import "./BrandArchiveGalleryImageModal.scss"

import {Swiper, SwiperSlide} from 'swiper/react';
import "swiper/swiper-bundle.css"
import {checkImgFormat, fetchAndReceiveJSON} from '../../../utils/utils';
import {ReviewBeforeArrow, ReviewNextArrow} from '../../../../assets/Arrows.jsx';
import CloseBtnIcon from "../../../../img/icon/mo-btn-gnb-close-32.svg"

const BrandArchiveGalleryImageModalComponent = ({
                                                    images,
                                                    close,
                                                    targetIndex
                                                }) => {

    const [controlledSwiper, setControlledSwiper] = useState(null);
    const [flag, setFlag] = useState(false)
    const scrollPosition = window.pageYOffset;


    useEffect(() => {
        if (images.length < 2) {
            const indication: HTMLElement = document.getElementsByClassName("swiper-pagination swiper-pagination-fraction")[0] as HTMLElement;
            if (indication) {
                indication.style.display = "none"
            }
        }
        if (
            /iP(hone)/.test(navigator.platform)
        ) {
            document.body.style.position = 'fixed';
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.top = `-${scrollPosition}px`;

        } else {
            document.body.style.overflow = 'hidden';
        }

        return () => {
            if (
                /iP(hone)/.test(navigator.platform)
            ) {
                document.body.style.removeProperty('position');
                document.body.style.removeProperty('left');
                document.body.style.removeProperty('right');
                document.body.style.removeProperty('top');
                window.scrollTo({left: 0, top: scrollPosition, behavior: "auto"});

            } else {
                document.body.style.removeProperty('overflow');
            }
        }
    }, [])
    useEffect(()=>{
        if(controlledSwiper){
            controlledSwiper.slideTo(targetIndex)
        }
    },[controlledSwiper])

    return (
        <>
            <div className="modal-bg" onClick={() => {
                close();
            }}></div>
            <div className="brand-archive-gallery-modal-wrapper">
                <div className="focusedPhotoReviewWrapper">
                    <div className="focusedPhotoReviewHeader">
                        <div className="focusedPhotoReviewReturn"
                             onClick={() => close()}></div>
                        <div className="focusedPhotoReviewClose" onClick={() => {
                            close();
                        }}>
                            <img src={CloseBtnIcon}/>
                        </div>
                    </div>
                    {images &&
                        <div className="positionWrapper">
                            <Swiper
                                spaceBetween={16}
                                slidesPerView={1}
                                centeredSlides={true}
                                centeredSlidesBounds={true}
                                updateOnWindowResize={true}
                                onSlideChange={() => setFlag(!flag)}
                                onSwiper={(swiper) => setControlledSwiper(swiper)}
                                pagination={{
                                    type: "fraction",
                                }}
                                navigation={
                                    {
                                        nextEl: '.swiper-button-next',
                                        prevEl: '.swiper-button-prev',
                                    }
                                }

                                loop={false}
                            >
                                {
                                    images.map((item, i) => {
                                            return (
                                                <SwiperSlide key={i}>
                                                    <div
                                                        className="focusThumbnail"
                                                        id={`focusThumbnail${i}`}
                                                        style={{
                                                            backgroundImage: checkImgFormat(item.url) ? `url(${item.url})` : ``,
                                                            paddingTop: checkImgFormat(item.url) ? "" : "0px",
                                                            height: checkImgFormat(item.url) ? "" : "350px"

                                                        }}>

                                                        {
                                                            !checkImgFormat(item.url) &&
                                                            <div style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                position: "relative"
                                                            }}>
                                                                <div style={{
                                                                    width: "30%",
                                                                    height: "60%",
                                                                    position: "absolute",
                                                                    top: "50px",
                                                                    left: 0
                                                                }}/>
                                                                <div style={{
                                                                    width: "30%",
                                                                    height: "60%",
                                                                    position: "absolute",
                                                                    top: "50px",
                                                                    right: 0
                                                                }}/>
                                                                <iframe width="100%" height="100%" src={item.url}
                                                                        frameBorder="no" scrolling="no" title="NaverVideo"
                                                                        allow="autoplay; gyroscope; accelerometer; encrypted-media allowfullscreen"></iframe>
                                                            </div>
                                                        }
                                                    </div>
                                                </SwiperSlide>
                                            )
                                        }
                                    )
                                }


                            </Swiper>

                            <div className="swiper-button-prev">
                                <ReviewBeforeArrow/>
                            </div>


                            <div className="swiper-button-next">

                                <ReviewNextArrow/>

                            </div>
                        </div>
                    }
                    <div
                        className={'text-caption'}>{images[controlledSwiper?.activeIndex ? controlledSwiper?.activeIndex : 0].caption.length > 0 ? images[controlledSwiper?.activeIndex ? controlledSwiper.activeIndex : 0].caption : " "}</div>
                </div>
            </div>
        </>

    );

}


export default BrandArchiveGalleryImageModalComponent